import styled from 'styled-components/macro';

export const DropzoneContainer = styled.div`
  width: 100%;
  min-height: 100px;
  border-style: dashed;
  border-color: ${({ theme }) => theme.dark};
  border-width: 1px;
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    min-height: 200px;
  }
`;

export const Message1 = styled.p`
  font-size: ${({ theme }) => theme.paragraph}px;
  color: ${({ theme }) => theme.dark};
  font-family: ${({ theme }) => theme.primaryFontMedium};
  text-align: center;
  line-height: ${({ theme }) => theme.paragraph + 5}px;
`;

export const Message2 = styled.p`
  font-size: ${({ theme }) => theme.paragraph}px;
  color: ${({ theme }) => theme.dark};
  font-family: ${({ theme }) => theme.primaryFontLight};
  text-align: center;
  line-height: ${({ theme }) => theme.paragraph + 5}px;
`;
